import {Directive, Inject, AfterViewInit, Input} from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwTouchStart
 * @module mw.components.touchStart
 * @restrict A
 *
 * @description
 * `mw-touch-start` is an attribute directive that will execute a function when touch starts or mouse down events.
 *
 * @usage
 * <hljs hljs-language="html">
 * <div mw-focus-when="$ctrl.focusFlag">
 * </div>
 * </hljs>
 */
@Directive({
    selector: '[mwTouchStart]'
})
export class TouchStartDirective implements AfterViewInit {

    constructor(@Inject('$element') private $element: ng.IRootElementService,
                @Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        'ngInject';
    }

    ngAfterViewInit() {

        const handleTouchOrMousedown = () => {
            const method = this.$element.attr('mw-touch-start');
            this.$scope.$apply(method); 
        }

        if(document.body.classList.contains('touch')) {
            this.$element.bind('touchstart', handleTouchOrMousedown);
        } else {
            this.$element.bind('mousedown', handleTouchOrMousedown);
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/resizer/touch-start.directive.ts